import React, {Dispatch, useState} from 'react';
import s from "../BankTransfer/BankTransfer.module.css";
import ToAnLuxPayStepOne from "./ToAnLuxPayStepOne/ToAnLuxPayStepOne";

type BankTransferPropsType = {
    isButtonDisable: boolean | undefined
    setIsButtonDisabled: Dispatch<React.SetStateAction<boolean>>
    tabIndex?: number
}

const ToAnLuxPay = (props: BankTransferPropsType) => {
    const [current, setCurrent] = useState(0);

    const steps = [
        {
            content: <ToAnLuxPayStepOne setCurrent={setCurrent}
                                        isButtonDisable={props.isButtonDisable}
                                        setIsButtonDisabled={props.setIsButtonDisabled}
                                        tabIndex={props.tabIndex}
            />
        },
    ];

    return (
        <>
            <div className={s.wrapper}>
                {steps[current].content}
            </div>
        </>

    );
};

export default ToAnLuxPay;
